import orderBy from 'lodash/orderBy';

export const tag = ({ items }) => orderBy(items, ['id'], ['desc'])
